import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';


export const ProgressGraphsStyles = muiStyled(Box)(({ color, theme }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    '.header-filters': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.content': {
        flexGrow: 1,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        rowGap: 10
    }
}));